export function registerServiceWorker() {
  if (!('serviceWorker' in navigator)) return;

  window.addEventListener('load', async () => {
    try {
      const registrations = await navigator.serviceWorker.getRegistrations();
      for (const registration of registrations) {
        if (registration.active && !registration.active.scriptURL.endsWith('/sw.js')) {
          console.warn('[Security] Unrecognized Service Worker detected. Terminating...', registration.active.scriptURL);
          await registration.unregister();
        }
      }
      
      await navigator.serviceWorker.register('/sw.js');
      console.log('[Sovereign] Background Loader Active');
    } catch (error) {
      console.error('[Sovereign] Loader failed:', error);
    }
  });
}
